module.exports = __webpack_public_path__ + "img/20230104-0331foaming_set_headder.61685243.jpg";